import { useQuery } from "@tanstack/react-query";
import fetch from "logic/rest/FetchProvider";
import { reportingUrl } from "report/Constants";
import i18n from "i18n";
import { defaultOnError } from "util/conditional/onError";
const deserializeResponse = ({
  _scope,
  delivery,
  description,
  hide_widget_description,
  hide_widget_query,
  id,
  layout,
  parameter_values,
  parameters,
  positions,
  subtitle,
  timezone,
  title,
  widgets,
  logo
}) => ({
  _scope,
  delivery,
  description,
  hideWidgetDescription: hide_widget_description,
  hideWidgetQuery: hide_widget_query,
  id,
  layout: layout ? {
    format: layout.format,
    pageSize: layout.page_size,
    orientation: layout.orientation,
    printHeader: layout.print_header,
    printFooter: layout.print_footer,
    printPageNumbers: layout.print_page_numbers,
    header: layout.header,
    footer: layout.footer,
    printToc: layout.print_toc
  } : void 0,
  parameterValues: Object.fromEntries(Object.entries(parameter_values).map(([name, { value }]) => [name, value])),
  parameters,
  positions,
  title,
  timezone,
  subtitle,
  widgets: widgets.map((w) => ({
    dashboardId: w.dashboard_id,
    widgetId: w.dashboard_widget_id,
    title: w.title,
    description: w.description,
    height: w.height
  })),
  logo
});
const fetchReport = (reportId) => fetch("GET", reportingUrl(`${reportId}/short`)).then((response) => deserializeResponse(response));
const useReport = (reportId, refetchPeriodically = false) => {
  const { data, isInitialLoading, isFetching, error } = useQuery({
    queryKey: ["reports", "details", reportId],
    queryFn: () => defaultOnError(
      fetchReport(reportId),
      i18n.t("notifications.fetch_report_failed", { ns: "enterprise_report" }),
      i18n.t("notifications.fetch_report_failed_title", { ns: "enterprise_report" })
    ),
    refetchInterval: refetchPeriodically ? 2e3 : void 0
  });
  return {
    data,
    isFetching,
    isInitialLoading,
    error
  };
};
export default useReport;
